module.exports = "<div class=\"col-md-12\">\n  <ul class=\"nav nav-tabs acntTabMenu\">\n    <li routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact:\ntrue}\">\n      <a routerLink=\"/schema\" >Schemas</a>\n    </li>\n    <li routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact:\ntrue}\">\n      <a routerLink=\"/schema/templates\">\n        Templates</a>\n    </li>\n  </ul>\n</div>\n<div class=\"col-md-12\">\n  <div class=\"col-md-12 tabContents\">\n    <router-outlet></router-outlet>\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/schema-list/schema-list.component.html
// module id = 1205
// module chunks = 0 2